<template>
    <div class="animated fadeIn">
        <div class="card" style="margin:0px 15px 10px 15px">
            <div class="row" style="padding: 20px;background-color:#fff">
                <div class="col-md-8">
                    <p style="font-size: 16px;">This pages shows the list of all pending loan requests awaitng approval or rejection</p>
                </div>
                <div class="col-md-4">
                    <p class="text-right">
                        <b-link to="#" v-show="!loading" @click="fetchData()">
                            <span class="fa fa-refresh"></span> Refresh Records
                        </b-link>
                    </p>
                </div>
            </div>
        </div>
        <b-row>
            <b-col lg="12" sm="12" md="12" xs="12">
                <b-card-group deck>
                    <b-card header="Pending Loan Requests">
                        <p v-if="loading" style="text-align: center;padding: 20px">
                            <span style="font-size: 25px;">
                                <i class="fa fa-spinner fa-spin"></i> Loading...
                            </span>
                        </p>
                        <div v-else>
                            <div v-if="tableData.length < 1">
                                <p style="font-size: 15px;" class="text-center">
                                    <i>There are currently no pending loans at this moment.</i>
                                </p>
                            </div>
                            <div v-else>
                                <v-client-table :data="tableData" :columns="columns" :options="options">
                                    <b-link slot="actions" slot-scope="props" to="#" @click="viewLoanDetails(props.row.actions)"><i class="fa fa-eye"> </i> View Details</b-link>
                                    <div slot="status" >
                                        <b-badge variant="warning" pill>Pending</b-badge>
                                    </div>
                                </v-client-table>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-md-6 col-sm-12 col-xs-12">
                                <div class="pagination">
                                    <span @click="getPaginated(1)">&laquo;</span>
                                        <strong v-for="(number,index) in pageNumbers" :key="index" @click="getPaginated(number)">
                                            <span v-if="number === 1 || number === total_pages || (number >= current_page - 2 && number <= current_page + 2)">{{number}}</span>
                                        </strong>
                                    <span @click="getPaginated(last_page)">&raquo;</span>
                                </div>
                            </div>
                        </div> -->
                    </b-card>
                </b-card-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { baseURL } from '../../shared/utils';
import { mapState, mapActions } from 'vuex';
import { allLoans, getLoanByStatus } from '@/services/loanService';

export default {
    name: 'pendingloans',
    data: () => {
        return {
            columns: ['name', 'type', 'reason', 'amount', 'status', 'date', 'actions'],
            tableData: [],
            per_page: 0,
            last_page: 0,
            total_pages: 0,
            current_page: 0,
            pageNumbers: [],
            loading: false,
            options: {
                headings: {
                    name: 'Customer Name',
                    type: 'Loan Type',
                    reason: 'Loan Reason',
                    amount: 'Amount(₦)',
                    status: 'Status',
                    date: 'Date',
                    actions: 'View Details'
                },
                sortable: ['name', 'status', 'date'],
                filterable: ['name', 'amount']
            }
        }
    },
    computed: {
      rows() {
        return this.tableData.length
      }
    },
    created () {
        this.fetchData(1);
    },
    methods: {
        async fetchData(page_number) {
            this.loading = true;
            try {
                this.tableData = [];
                let {data} = await getLoanByStatus(1);
                data.loans.map((loan, index) => {
                    this.tableData.push({
                        id: ++index,
                        name: `${loan.user.first_name} ${loan.user.last_name}`,
                        type: loan.loan_type.name,
                        reason: loan.loan_reason.name,
                        amount: `₦${parseInt(loan.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`,
                        status: loan.loan_status_id,
                        date: loan.application_date,
                        actions: loan.id
                    });
                });
            }
            catch(error) {
                console.log(error);
            }
            finally {
                this.loading = false;
            }
        },
        getPaginated(page_number) {
            this.fetchData(page_number);
        },
        setData(data) {
            let total_pages, last_page, current_page, per_page;
            let page_numbers = [];

            if(data) {
                total_pages = data.total;
                last_page = data.last_page;
                current_page = data.current_page;
                per_page = data.total;
            }
            else {
                total_pages = 0;
                last_page = 0;
                current_page = 0;
                per_page = 0;
            }

            for (let i = 1; i <= Math.ceil(total_pages / data.per_page); i++) {
                page_numbers.push(i);
            }

            this.current_page = current_page;
            this.total_pages = total_pages;
            this.last_page = last_page;
            this.per_page = per_page;
            this.pageNumbers = page_numbers;
        },
        viewLoanDetails(id) {
            this.$router.push(`/loans/${id}`);
        }
    }
}
</script>

<style scoped>
    .pagination {
        margin-top: 25px;
    }

    .pagination span {
        cursor: pointer;
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
        border: 1px solid #ddd;
    }

    .pagination span.active {
        background-color: #15974b;
        color: white;
        border: 1px solid #15974b;
    }
</style>
